import { rtkApi } from '#adapter/api/campaigns/v5/supplier';

interface IProps {
    query?: {
        status_id?: Array<number>
    }
}

export const useSupplierFetch = ({ query }: IProps | undefined = {}) => {
    const {
        data,
        isLoading,
        isFetching,
        error,
        isUninitialized,
        refetch
    } = rtkApi.endpoints.getApiV5Supplier.useQuery({ statusId: query?.status_id });

    const cashback = data?.cashback;
    const bonuses = data?.bonuses;
    const contract = data?.contract;
    const contractId = data?.contractId;
    const isSpecial = !!data?.isSpecial;

    const isNoContract = (!contractId || contractId === 0) && !isSpecial;

    const hasNoAdverts = data && !data.hasAnyAdverts;

    return {
        data,
        error,
        isLoading,
        isFetching,
        refetch: isUninitialized ? undefined : refetch,
        isNoContract,
        contractId,
        isSpecial,
        cashback,
        bonuses,
        contract,
        hasNoAdverts
    };
};
